<template>
    <div class="expand" v-if="canExpand">
        <el-link :underline="false" type="primary" icon="el-icon-full-screen" @click="handleExpand">
            Rozciągnij
        </el-link>
    </div>
</template>

<script>
import Editor from '../../../classes/Editor'

export default {
    data() {
        return {
            currentObject: false
        }
    },
    computed: {
        canExpand() {
            return this.currentObject && this.currentObject.type !== 'textbox'
        }
    },
    methods: {
        handleExpand() {
            const object = Editor.canvas.getActiveObject()  
            const aspect = object.width / object.height

            object.set({
                scaleX: Editor.width / object.width,
                scaleY: Editor.width / (object.height * aspect),
                top: 0,
                left: 0
            })

            Editor.canvas.renderAll()
        },
    },
    mounted() {
        Editor.addCallback(['selection:created', 'selection:updated'], () => {
            this.currentObject = Editor.canvas.getActiveObject()
        })

        Editor.addCallback('selection:cleared', () => {
            this.currentObject = false
        })
    },
}
</script>

<style scoped>
.el-link,
.el-link.el-link--primary {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}
</style>